<template>
  <div
    class="relative h-full"
    :class="{'hide-entries-board': presentation.isHideEntrySpinnerWheen && isPresenting}"
  >
    <div class="h-full spinner-wheel-table __container horizontal layout">
      <aha-svg
        v-if="variant === 'white'"
        maintain-color
        class="spinner-wheel-table __wrapper"
        name="spinner-wheel-bg-white-v2"
        viewBox="0 0 800 512"
        width="800"
        height="512"
      />

      <aha-svg
        v-else
        maintain-color
        class="spinner-wheel-table __wrapper"
        name="spinner-wheel-bg-dark-v2"
        viewBox="0 0 800 512"
        width="800"
        height="512"
      />

      <img
        src="@/assets/images/spinner-wheel-table/wheel-border-round.svg"
        class="spinner-wheel-table __wrapper custom"
        v-if="variant === 'white'"
      >

      <img
        v-else
        src="@/assets/images/spinner-wheel-table/border_dark.svg"
        class="spinner-wheel-table __wrapper custom"
      >

      <div class="spinner-wheel-table __entries">
        <div class="spinner-wheel-table __entries-box vertical layout spinner-wheel-table__container">
          <transition name="fade">
            <div class="spinner-wheel-table__entries toast-spinner-wheel" v-if="showTop">
              <aha-icon
                class="text-green-50"
                name="circle-check"
                viewBox="0 0 24 24"
                width="16"
                height="16"
              />
              <span>{{ $t('An entry has been removed') }}</span>
            </div>
          </transition>
          <div class="spinner-wheel-table __label">
            <spinner-wheel-label
              :show-winner="showWinner"
              :background-color="currentStyle"
              :text="currentText"
              :variant="variant"
            />
          </div>
          <SpinnerWheelEntries
            class="flex"
            :entries="entries"
            :createNewEntry="createNewEntry"
            :removeEntry="removeEntry"
            :variant="variant"
            :resetSpinnerWheel="resetSpinnerWheel"
            :isUserOwnPresentation="isUserOwnPresentation"
            :oldEntryFromAudienceCount="oldEntryFromAudienceCount"
            :pendingEntriesCount="pendingEntriesCount"
            :oldWinner="oldWinner"
            :countWheelEntries="countWheelEntries"
          />
        </div>
      </div>
      <div class="spinner-wheel-table __wheel vertical layout">
        <spinner-wheel
          :entries="wheelEntries"
          :select-segment="selectCurrentEntry"
          :start-the-wheel="startTheWheel"
          :stop-the-wheel="stopTheWheel"
          :winner="winner"
          :old-winner="oldWinner"
          :isUserOwnPresentation="isUserOwnPresentation"
        />
      </div>
      <spinner-wheel-winner-popup
        v-if="showWinner"
        :close-show-winner="closeShowWinner"
        :background-color="currentStyle"
        :text="currentText"
        :variant="variant"
        @remove-winner-entry="removeEntryWinner"
      />
    </div>
  </div>
</template>
<script>

// container
import { mapState, mapGetters, mapActions } from 'vuex'

import SpinnerWheel from './SpinnerWheel.vue'
import SpinnerWheelEntries from './SpinnerWheelEntries.vue'
import SpinnerWheelLabel from './SpinnerWheelLabel.vue'
import SpinnerWheelWinnerPopup from './SpinnerWheelWinnerPopup.vue'
import Socket from '@/socket'
import SlideOptionApi from '@/api/slideOption'
import Util from '@/util'
import eventCategories from '@/constant/eventCategories'

export default {
  components: {
    SpinnerWheel,
    SpinnerWheelLabel,
    SpinnerWheelWinnerPopup,
    SpinnerWheelEntries,
  },
  props: {
    variant: {
      type: String,
      default: 'white',
    },
    currentStyle: {
      type: String,
      default: '',
    },
    currentText: {
      type: String,
      default: '',
    },
    entries: {
      type: Array,
      default: () => {
        return []
      },
    },
    wheelEntries: {
      type: Array,
      default: () => {
        return []
      },
    },
    createNewEntry: {
      type: Function,
      default: () => {
        return null
      },
    },
    removeEntry: {
      type: Function,
      default: () => {
        return null
      },
    },
    startTheWheel: {
      type: Function,
      default: () => null,
    },
    stopTheWheel: {
      type: Function,
      default: () => null,
    },
    winner: {
      type: Object,
      default: null,
    },
    oldWinner: {
      type: Object,
      default: null,
    },
    oldEntries: {
      type: Array,
      default: () => [],
    },
    closeShowWinner: {
      type: Function,
      default: () => null,
    },
    showWinner: {
      type: Boolean,
      default: false,
    },
    resetSpinnerWheel: {
      type: Function,
      default: () => {
        return null
      },
    },
    selectCurrentEntry: {
      type: Function,
      default: () => {
        return null
      },
    },
    isUserOwnPresentation: {
      type: Boolean,
      default: false,
    },
    pendingEntriesCount: {
      type: Number,
      default: 0,
    },
    oldEntryFromAudienceCount: {
      type: Number,
      default: 0,
    },
    countWheelEntries: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    ...mapGetters(['isPresenting']),
    ...mapState({
      slide: (state) => state.slideActive,
      presentation: (state) => state.presentation,
    }),
  },
  data() {
    return {
      showTop: false,
    }
  },
  methods: {
    ...mapActions(['updateSlideActiveAction']),
    removeEntryWinner() {
      if (!this.oldWinner) {
        return
      }
      this.showTop = true
      setTimeout(() => {
        this.showTop = false
      }, 3000)
      const entry = {
        entryType: this.oldWinner.entryType,
        id: this.oldWinner.winnerId,
        index: this.oldWinner.winnerIndex,
        label: this.oldWinner.winnerLabel,
      }
      if ((!this.isUserOwnPresentation) || this.isBackstage) return
      if (this.slide.wheelStatus === 'spinning') return
      if (entry.entryType === 'manual_presenter') {
        const payload = {
          accessCode: this.presentation.uniqueAccessCode,
          deleted: true,
          presentationId: this.presentation.id,
          presenting: false,
          socketId: Socket.getSocketId(),
        }
        try {
          SlideOptionApi.updateSlideOption(entry.id, payload)
          const indexOption = this.$store.state.slideActive.SlideOptions.findIndex((item) => {
            return item.id === entry.id
          })
          if (indexOption !== -1) {
            this.$store.state.slideActive.SlideOptions.splice(indexOption, 1)
          }

          this.updateSlideActiveAction({
            SlideOptions: this.slide.SlideOptions,
          })
        } catch (e) {
          console.log(e)
          this.$store.dispatch('setSyncPresentation', 3)
          // do notthing
        }
      }
      this.removeEntry(entry)
      Util.mixpanelTracking(
        eventCategories.PRESENTATION_EDITOR,
        'Spinner Wheel > Entries list > Remove winner entry',
      )
    },
  },
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/variable.scss";
.spinner-wheel-table {
  &.__wrapper {
    @apply absolute;
  }

  &.__entries {
    width: $spinner-wheel-left-part-width;
  }

  &.__entries-box {
    height: 358px;
    position: relative;
    top: 71px;
    padding-left: 28px;
    padding-right: 10px;
    padding-bottom: 15px;
  }

  &.__container {
    width: 800px;
    margin: 0 auto
  }

  &.__label {
    @apply flex items-center justify-center;
    height: 70px;
    width: $spinner-wheel-left-part-width;
    margin-left: -16px;
    margin-top: 2px;
  }

  &::v-deep audio {
    border: 2px solid #ccc;
    border-radius: 30px;
    height: 32px;
    position: absolute;
    top: -50px;
    width: 288px;
    left: 33px;
  }

  .hide-audio {
    visibility: hidden;
  }
}

.spinner-wheel-table.__wrapper.custom {
  display: none;
}

.hide-entries-board {
  &::v-deep {
    .entries-box {
      display: none;
    }
  }
}

.spinner-wheel-table__container{
  position: relative;
  .spinner-wheel-table__entries{
    position: absolute;
    top: -45px;
    left: 5px;

    background: #EEF9F1;
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    padding: 10px;
    width: 100%;
    border-radius: 4px;
    border: 1px solid #428f51;
    span{
      height: 18px;
      font-style: normal;
      font-weight: 700;
      font-size: 14px;
      line-height: 18px;
      padding: 4px 4px 4px 4px;

      display: flex;
      align-items: center;

      color: #4A9459;
    }

  }
}

.fade-enter-active, .fade-leave-active {
  transition: all 1s ease;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  transform: translateY(20px);
  opacity: 0;
}

</style>
